import { SelectCombo } from 'components/Types/GeneralTypes';
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import AsyncCreatableSelect from 'react-select/async-creatable';

import { StylesConfig } from 'react-select';
import Icon from '../Icons';


type propsCreateSelect = {
    value: SelectCombo | undefined,
    opciones: SelectCombo[],
    icon: string,
    placeholder: string,
    onCreate: (newValue: SelectCombo) => Promise<void>,
    onChange: (value: SelectCombo | undefined) => void,

}

export default function CreateSelect(props: propsCreateSelect) {

    const [value, setvalue] = useState<SelectCombo | undefined>(undefined)
    const [options, setoptions] = useState<SelectCombo[]>([])

    useEffect(() => {
        if(props.value === undefined){
            setvalue({label:"",value:""})
        }
        else {
            setvalue(props.value)
        }
    }, [props.value])

    useEffect(() => {
        setoptions(props.opciones)
    }, [props.opciones])







    const handleChange = (newValue: SelectCombo | undefined) => {
        if (newValue) {
            setvalue(newValue);
        }

        props.onChange(newValue);

    };


    async function handleCreateOption(inputValue: string) {
        const newOption = { label: inputValue, value: inputValue.toUpperCase().trim() };
        setoptions((prev) => {
            return [...prev, newOption]
        }
        )
        await props.onCreate(newOption)
    };

    const formatCreateLabel = (inputValue: string) => `Crear nuevo grupo "${inputValue}"`;

    const customStyles: StylesConfig<SelectCombo, false> = {
        container: (provided, state) => ({
            ...provided,
            position: "relative",
            width: "100%",
            marginBottom: "0",
        }),
        control: (provided, state) => {
            const backgroundColor = state.isDisabled ? "#E3E3E3" : "#fff";
            return {
                ...provided,
                borderRadius: "0px",
                border: "1px solid #E3E3E3",
                backgroundColor,
                color: "#2c2c2c",
                minHeight: "27px",
                height: "27px",
                fontSize: "0.8571em",
                boxShadow: "none",
                width: "auto",
                fontFamily: "Montserrat",
            }
        },
        indicatorSeparator: () => ({
            display: 'none',
        }),
        menu: (provided, state) => ({
            ...provided,
            fontSize: "0.95em",
            minWidth: "300px",
            zIndex: "100",
        }),
        clearIndicator: (provided, state) => ({
            ...provided,
            color: 'red', // Cambia el color
            padding: '0px',
            cursor: 'pointer',
            svg: {
                height: '20px', // Aumenta el tamaño
                width: '20px',
            }
        }),
    }

    // Función para normalizar el texto
    const normalizeString = (str: string) => {
        // Definir la expresión regular usando new RegExp
        const accentRegex = new RegExp('[\u0300-\u036f]', 'g');
        // Convertir el texto a mayúsculas y eliminar las tildes
        const formattedValue = str
            .toUpperCase() // Convertimos a mayúsculas
            .normalize('NFD') // Descomponemos los caracteres con tildes
            .replace(accentRegex, ''); // Eliminamos las tildes utilizando el objeto RegExp
        return formattedValue
    };



    const loadOptions = useCallback((inputValue: string, callback: (options: SelectCombo[]) => void) => {
        const normalizedInput = normalizeString(inputValue);

        // Si no hay entrada, mostrar las opciones por defecto
        if (!normalizedInput) {
            callback(options);
            return;
        }

        // Filtrar las opciones normalizadas
        const filteredOptions = options.filter(option =>
            normalizeString(option.label).includes(normalizedInput)
        );

        callback(filteredOptions);
    }, [options])


    // Convertir el input a mayúsculas al escribir
    const handleInputChange = (newValue: string) => {
        return newValue.toUpperCase();
    };

    return (
        <div className="input-group">
            <AsyncCreatableSelect
                value={value}
                onChange={handleChange}
                onCreateOption={handleCreateOption}
                loadOptions={loadOptions}
                defaultOptions={options}
                isClearable
                formatCreateLabel={formatCreateLabel}
                styles={customStyles}
                placeholder={props.placeholder}
                onInputChange={handleInputChange}
            />
            <div className="icon-inside-select" style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)" }}>
                {props.icon.startsWith("fa-") ? (<i className={"fas " + props.icon} aria-hidden="true" ></i>) : (<Icon kind={props.icon} fill='#FF0000' width={10} height={10} />)}
            </div>
        </div>

    )
}
